import React, { useEffect, useRef } from 'react';
import { isNotNilOrEmpty } from '@pcty/utils';
var AccessibleStatus = React.forwardRef(function (_a, ref) {
    var id = _a.id, message = _a.message;
    var statusA = useRef(null);
    var statusB = useRef(null);
    var status = useRef('A');
    useEffect(function () {
        var _a;
        if (isNotNilOrEmpty((_a = statusA.current) === null || _a === void 0 ? void 0 : _a.innerText)) {
            status.current = 'B';
            return;
        }
        status.current = 'A';
    }, [message]);
    var getStatus = function (div) {
        if (status.current !== div)
            return;
        return message;
    };
    return (React.createElement("div", { ref: ref, style: {
            border: 0,
            clip: 'rect(0px, 0px, 0px, 0px)',
            height: 1,
            marginBottom: -1,
            marginRight: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: 1,
        } },
        React.createElement("div", { "aria-atomic": "true", "aria-live": "polite", id: id + '-status-a', ref: statusA, role: "status" }, getStatus('A')),
        React.createElement("div", { "aria-atomic": "true", "aria-live": "polite", id: id + '-status-b', ref: statusB, role: "status" }, getStatus('B'))));
});
export default AccessibleStatus;
